<template>
  <nav
    class="
      navbar navbar-main navbar-expand
      px-0
      shadow-none
      border-radius-xl
      zindex-over-sticky
      position-fixed
      w-100
    "
    id="navbarBlur"
    data-scroll="false"
  >
    <div class="container-fluid pt-0 px-3 d-flex flex-column-reverse">
      <nav aria-label="breadcrumb" class="align-self-start">
        <button
          type="button"
          class="toggle-menu text-lg position-static float-start py-1 me-3"
          @click="onToggleMenu()"
        >
          <i class="fas fa-bars"></i>
        </button>
        <button
          type="button"
          class="mobile-toggle text-lg position-static float-start py-1 me-3"
          @click="onToggleMenuMobile()"
        >
          <i class="fas fa-bars"></i>
        </button>
        <ol
          class="
            breadcrumb
            float-start
            bg-transparent
            mb-0
            pb-0
            pt-2-custom
            px-0
            me-sm-6 me-5
          "
        >
          <li class="breadcrumb-item text-sm">
            <a class="opacity-5 text-white" href="javascript:;">
              {{ $route.meta.type }}</a
            >
          </li>
          <li
            class="breadcrumb-item text-sm text-white active"
            aria-current="page"
          >
            {{ $route.meta.page }}
          </li>
        </ol>
        <h6 class="font-weight-bolder text-white mb-0 lh-sm">
          {{ $route.meta.title }}
        </h6>
      </nav>
      <div
        class="pt-1-custom d-flex flex-row w-100 justify-content-between"
        id="navbar"
      >
        <div class="pe-md-3 d-flex align-items-center w-42 overflow-hidden">
          <a class="navbar-brand m-0" href="javascript:;" target="_blank">
            <img
              src="https://djangompg.blob.core.windows.net/media/images/mansfield-energy-logo.png"
              class="navbar-brand-img w-100-custom"
            />
          </a>
        </div>
        <ul class="navbar-nav justify-content-end">
          <li class="nav-item d-flex align-items-center px-2">
            <a
              @click="$bvModal.show('activity_modal')"
              href="javascript:;"
              class="nav-link text-primary p-0"
            >
              <CalendarIcon />
            </a>
          </li>
          <li class="nav-item d-flex align-items-center">
            <a
              href="javascript:;"
              class="nav-link text-primary font-weight-bold px-0"
            >
              <i class="fa fa-user me-sm-1"></i>
              <span class="d-sm-inline d-none">{{
                user.username || "Loading..."
              }}</span>
            </a>
          </li>
          <li class="nav-item ps-3 d-flex align-items-center">
            <a
              @click="$bvModal.show('add_task_modal')"
              href="javascript:;"
              class="nav-link text-primary p-0"
            >
              <i
                class="
                  fas
                  fa-clipboard-list
                  fixed-plugin-button-nav
                  cursor-pointer
                "
              ></i>
            </a>
          </li>

          <li class="nav-item ps-3 d-flex align-items-center">
            <a
              @click="$bvModal.show('add_schedule_modal')"
              href="javascript:;"
              class="nav-link text-primary p-0"
            >
              <i
                class="
                  fas
                  fa-people-arrows
                  fixed-plugin-button-nav
                  cursor-pointer
                "
              ></i>
            </a>
          </li>

          <li class="nav-item ps-3 d-flex align-items-center">
            <a
              @click="$bvModal.show('add_message_modal')"
              href="javascript:;"
              class="nav-link text-primary p-0"
            >
              <i
                class="fas fa-envelope fixed-plugin-button-nav cursor-pointer"
              ></i>
            </a>
          </li>

          <li class="nav-item ps-3 d-flex align-items-center">
            <router-link class="nav-link text-primary p-0" to="/account/logout">
              <i class="fas fa-power-off"></i>
            </router-link>
          </li>
        </ul>
      </div>
    </div>

    <b-modal
      id="activity_modal"
      tabindex="-1"
      aria-labelledby="activity_modal_label"
      aria-hidden="true"
      hide-footer
      size="xxl"
      @show="onShowMsgModal"
      @hide="onHideTask"
    >
      <template #modal-header>
        <h6 class="text-center mb-0">Calendar</h6>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          :disabled="loadingAction"
          @click="$bvModal.hide('activity_modal')"
        ></button>
      </template>

      <div v-if="isReady">
        <div style="min-height: 80vh">
          <Activities/>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="add_task_modal"
      tabindex="-1"
      aria-labelledby="add_task_modal_label"
      aria-hidden="true"
      hide-footer
      @show="onShowMsgModal"
      @hide="onHideTask"
    >
      <template #modal-header>
        <h6 class="text-center mb-0">TASK</h6>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          :disabled="loadingAction"
          @click="$bvModal.hide('add_task_modal')"
        ></button>
      </template>

      <div v-if="isReady">
        <div class="d-grid gap-2 d-md-block text-start">
          <div v-if="loadingAction">
            <div
              class="
                text-center
                d-flex
                justify-content-center
                py-3
                align-items-center
              "
              style="min-height: 448.17px"
            >
              <b-spinner class="mx-auto"></b-spinner>
            </div>
          </div>
          <form
            v-if="!loadingAction"
            @submit.prevent="onSubmitAddTask"
            novalidate
            enctype="multipart/form-data"
            :class="
              submitted ? 'needs-validation was-validated' : 'needs-validation'
            "
          >
            <input
              type="hidden"
              name="csrfmiddlewaretoken"
              value="5IvRf0lCfcVx5g8yX9FxZEK291PaKbC0E1KxuYxDTpkyJLzEnst6wagT8fXUeaPc"
            />
            <input
              type="text"
              name="task_title"
              id="first_name_id"
              class="form-control"
              maxlength="255"
              required=""
              placeholder="Title"
              v-model.trim="$v.name.$model"
            />

            <div v-if="submitted && !$v.name.required" class="invalid-tooltip">
              Title is required
            </div>

            <p></p>

            <label for="legal_entity_id">Legal Entity*</label>
            <v-select
              v-model.trim="legal_entity"
              :options="legalEntityList"
            ></v-select>
            <p></p>
            <VueEditor v-model.trim="$v.description.$model" />
            <div
              v-if="submitted && !$v.description.required"
              class="invalid-tooltip"
            >
              Description is required
            </div>
            <p></p>
            <div class="row">
              <div class="col-12 col-md-6 mb-2">
                <v-select
                  placeholder="Time Needed"
                  v-model.trim="$v.time_needed.$model"
                  :options="[
                    { label: '15 Minutes', code: '15' },
                    { label: '20 Minutes', code: '20' },
                    { label: '30 Minutes', code: '30' },
                    { label: '45 Minutes', code: '45' },
                    { label: '60 Minutes', code: '60' },
                    { label: 'Custom', code: 'custom' },
                  ]"
                ></v-select>

                <input
                  type="number"
                  max="60"
                  min="1"
                  v-model="customTimeNeeded"
                  class="form-control mt-2"
                  placeholder="Enter your time needed"
                  v-if="time_needed.code === 'custom'"
                  @input="updateValue"
                />

                <div
                  v-if="submitted && !$v.time_needed.required"
                  class="invalid-tooltip"
                >
                  Time Needed is required
                </div>
              </div>

              <div class="col-12 col-md-6 mb-3">
                <v-select
                  placeholder="Completed Within"
                  v-model.trim="$v.completed_within.$model"
                  :options="[
                    { label: '1 Days', code: '1' },
                    { label: '2 Days', code: '2' },
                    { label: '3 Days', code: '3' },
                    { label: '5 Days', code: '5' },
                    { label: '10 Days', code: '10' },
                    { label: '14 Days', code: '14' },
                    { label: 'Custom', code: 'custom' },
                  ]"
                ></v-select>
                <date-range-picker
                  class="mt-2"
                  v-if="completed_within.code === 'custom'"
                  ref="picker"
                  v-model="dateRangeTime"
                >
                  <template v-slot:input="picker" style="min-width: 100%">
                    {{ moment(picker.startDate).format("MM/DD/YYYY") }} -
                    {{ moment(picker.endDate).format("MM/DD/YYYY") }}
                  </template>
                </date-range-picker>

                <div
                  v-if="submitted && !$v.completed_within.required"
                  class="invalid-tooltip"
                >
                  Completed is required
                </div>
              </div>
            </div>
            <div class="d-flex flex-row">
              <button
                class="btn btn-primary btn-sm ms-auto waves-effect waves-light"
                type="submit"
                name="delete_opportunity"
                :disabled="loadingAction"
              >
                Save
              </button>
              <button
                class="
                  btn btn-outline-primary btn-sm
                  ms-2
                  waves-effect waves-light
                "
                type="button"
                :disabled="loadingAction"
                data-bs-dismiss="modal"
                @click="$bvModal.hide('add_task_modal')"
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="add_schedule_modal"
      tabindex="-1"
      size="xl"
      aria-labelledby="add_schedule_modal_label"
      aria-hidden="true"
      hide-footer
      @show="onShowScheduleModal"
      @hide="onHideSchedule"
    >
      <template #modal-header>
        <h6 class="text-center">SCHEDULER</h6>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          :disabled="loadingAction"
          @click="$bvModal.hide('add_schedule_modal')"
        ></button>
      </template>

      <div class="modal-body">
        <div class="gap-2 text-center" v-if="user">
          <div class="row">
            <div class="col-12 col-md-7">
              <form
                @submit.prevent="onSubmitAddSchedule"
                novalidate
                enctype="multipart/form-data"
                :class="
                  submitted
                    ? 'needs-validation was-validated'
                    : 'needs-validation'
                "
              >
                <input
                  type="hidden"
                  name="csrfmiddlewaretoken"
                  value="5IvRf0lCfcVx5g8yX9FxZEK291PaKbC0E1KxuYxDTpkyJLzEnst6wagT8fXUeaPc"
                />

                <input
                  type="text"
                  name="scheduler_title"
                  id="first_name_id"
                  class="form-control"
                  maxlength="255"
                  required=""
                  placeholder="Title"
                  v-model="title_schedule"
                />

                <p></p>

                <div class="input-group mb-3">
                  <span class="input-group-text" id="basic-addon1">
                    <i class="far fa-clock"></i>
                  </span>
                  <input
                    type="datetime-local"
                    class="form-control"
                    placeholder="From"
                    aria-label="from_date"
                    aria-describedby="basic-addon1"
                    v-model="from_schedule"
                  />
                  <span class="input-group-text" id="basic-addon1"> To </span>
                  <input
                    type="datetime-local"
                    class="form-control"
                    aria-label="to_date"
                    aria-describedby="basic-addon1"
                    v-model="to_schedule"
                  />
                </div>

                <p></p>

                <div class="input-group mb-3">
                  <span class="input-group-text" id="basic-addon1">
                    <i class="fas fa-ellipsis-h"></i>
                  </span>

                  <multiselect
                    v-model="selected_user_schedule"
                    :options="listParticipants"
                    :multiple="true"
                    :close-on-select="false"
                    :clear-on-select="false"
                    :preserve-search="true"
                    placeholder="Type to search..."
                    label="email"
                    track-by="id"
                  >
                    <template slot="selection" slot-scope="{ values, isOpen }"
                      ><span
                        class="multiselect__single"
                        v-if="values.length &amp;&amp; !isOpen"
                        >{{ values.length }} options selected</span
                      ></template
                    >
                    <template slot="option" slot-scope="props">
                      <div class="option__desc">
                        <span class="option__title"
                          >{{ props.option.first_name }}
                          {{ props.option.last_name }}</span
                        >
                        <span class="option__small">{{
                          props.option.email
                        }}</span>
                      </div>
                    </template>
                  </multiselect>
                </div>
                <p></p>
                <VueEditor v-model="description_schedule" />
                <button
                  class="btn btn-primary mt-3 waves-effect waves-light"
                  type="button"
                  name="delete_opportunity"
                  :disabled="loadingAction"
                  @click="saveEvent()"
                >
                  Save
                </button>
                <button
                  class="btn btn-light mt-3 waves-effect waves-light"
                  type="button"
                  :disabled="loadingAction"
                  data-bs-dismiss="modal"
                  @click="$bvModal.hide('add_schedule_modal')"
                >
                  Cancel
                </button>
              </form>
            </div>
            <div class="col-12 col-md-5 position-relative">
              <div v-if="loadingCalendar" class="wrap-loading-calendar">
                <b-spinner class="align-middle mr-2"></b-spinner>
              </div>

              <FullCalendar ref="fullCalendar" :options="calendarOptions" />
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="add_message_modal"
      tabindex="-1"
      aria-labelledby="add_message_modal_label"
      aria-hidden="true"
      hide-footer
      @show="onShowMsgModal"
      @hide="onHideMessage"
    >
      <template #modal-header>
        <h6 class="text-center">MESSAGE</h6>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          :disabled="loadingAction"
          @click="$bvModal.hide('add_message_modal')"
        ></button>
      </template>

      <div class="modal-body">
        <div class="d-grid gap-2 d-md-block text-center">
          <form
            @submit.prevent="onSubmitSendMessage"
            novalidate
            enctype="multipart/form-data"
            :class="
              submitted ? 'needs-validation was-validated' : 'needs-validation'
            "
          >
            <input
              type="hidden"
              name="csrfmiddlewaretoken"
              value="5IvRf0lCfcVx5g8yX9FxZEK291PaKbC0E1KxuYxDTpkyJLzEnst6wagT8fXUeaPc"
            />

            <input
              type="text"
              name="first_name"
              id="first_name_id"
              class="form-control"
              maxlength="255"
              required=""
              placeholder="Subject Line"
              v-model.trim="$v.msg.subject.$model"
            />

            <div
              v-if="submitted && !$v.msg.subject.required"
              class="invalid-tooltip"
            >
              This field is required
            </div>

            <p></p>

            <div class="input-group mb-3">
              <span class="input-group-text" id="basic-addon1">
                <i class="fas fa-ellipsis-h"></i>
              </span>

              <multiselect
                v-model.trim="$v.msg.to.$model"
                :options="listParticipants"
                :multiple="false"
                :close-on-select="true"
                :clear-on-select="true"
                :preserve-search="true"
                placeholder="Type to search..."
                label="email"
                track-by="id"
              >
                <template slot="option" slot-scope="props">
                  <div class="option__desc">
                    <span class="option__small">{{ props.option.email }}</span>
                  </div>
                </template>
              </multiselect>
              <div
                v-if="submitted && !$v.msg.to.required"
                class="invalid-tooltip"
              >
                This field is required
              </div>
            </div>

            <p></p>

            <VueEditor v-model.trim="$v.msg.text.$model" />

            <div
              v-if="submitted && !$v.msg.text.required"
              class="invalid-tooltip"
            >
              This field is required
            </div>

            <button
              class="btn btn-primary mt-3 waves-effect waves-light"
              type="submit"
              name="delete_opportunity"
              :disabled="loadingAction"
            >
              Send
            </button>
            <button
              class="btn btn-light mt-3 waves-effect waves-light"
              type="button"
              :disabled="loadingAction"
              data-bs-dismiss="modal"
              @click="$bvModal.hide('add_message_modal')"
            >
              Cancel
            </button>
          </form>
        </div>
      </div>
    </b-modal>
  </nav>
</template>

<script>
import { VueEditor } from 'vue2-editor'
import DateRangePicker from 'vue2-daterange-picker'

import { authenticationService } from '../services/authentication.service'
import { utilService } from '../services/util.service'
import { todoService } from '../services/todo.service'
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import listPlugin from '@fullcalendar/list'
import { activitiyService } from '../services/activities.service'
import moment from 'moment'
import { required } from 'vuelidate/lib/validators'
import * as nylas from '../services/nylas.service'
import { bus } from '../main'
import { organizationsService } from '@/services/organizations.service'
import { CalendarIcon } from '@iconicicons/vue'
import Activities from '@/pages/Activities'

export default {
  components: {
    VueEditor,
    FullCalendar,
    DateRangePicker,
    CalendarIcon,
    Activities
  },
  data () {
    return {
      user: {},
      loadingAction: false,
      submitted: false,
      calendarOptions: {
        plugins: [dayGridPlugin, interactionPlugin, listPlugin],
        initialView: 'listWeek',
        events: [],
        height: 452,
        eventClick: this.showEvent
      },
      loadingCalendar: true,
      loadingCalendarAction: true,
      events: [],
      selected_user_schedule: [],
      listParticipants: [],
      description_schedule: '',
      from_schedule: '',
      to_schedule: '',
      title_schedule: '',
      userInfor: null,
      name: '',
      description: '',
      time_needed: '',
      completed_within: '',
      dateRangeTime: { startDate: new Date(), endDate: new Date() },
      customTimeNeeded: '',
      msg: {
        to: '',
        subject: '',
        text: ''
      },
      legal_entity: '',
      legalEntityList: [],
      isReady: false,
      isOpenMobile: false
    }
  },
  validations: {
    name: { required },
    description: { required },
    time_needed: { required },
    completed_within: { required },
    msg: {
      to: { required },
      subject: { required },
      text: { required }
    }
  },
  created () {
    this.userInfor = utilService.userInforValue

    if (authenticationService.currentUserValue) {
      utilService.getCurrentUser().then((rs) => {
        this.user = rs
      })
    }

    organizationsService
      .getData({
        q: '',
        ordering: '',
        limit: '9999999999',
        offset: 0,
        expands: ''
      })
      .then((rs) => {
        this.legalEntityList = rs.results.map((e) => {
          e.label = e.name
          e.code = e.organization_id
          return e
        })
        utilService.setListOrg(this.legalEntityList)
        bus.$emit('orgData', this.legalEntityList)
      })
  },
  methods: {
    moment,
    showEvent () {},
    onToggleMenu () {
      bus.$emit('toggleMenu', 'toggle')
    },

    onToggleMenuMobile () {
      this.isOpenMobile = !this.isOpenMobile
      bus.$emit('toggleMenuMobile', 'toggle')
    },

    async saveEvent () {
      this.loadingCalendarAction = true
      if (
        this.description_schedule === '' ||
        this.title_schedule === '' ||
        this.start_schedule === ''
      ) {
        this.$bvToast.toast('Please enter all fields required.', {
          title: `Validation`,
          variant: 'danger'
        })
        return
      }

      const payload = {
        title: this.title_schedule,
        description: this.description_schedule,
        start: moment(this.from_schedule).unix(),
        end: moment(this.to_schedule).unix(),
        participants: this.selected_user_schedule
      }
      try {
        activitiyService.addData(payload).then((rs) => {
          this.$bvModal.hide('add_schedule_modal')
          this.$bvModal.hide('event-modal-view')
          this.$bvModal.hide('add_schedule_event_modal')
          const evt = {
            title: rs.title,
            data: rs,
            date: rs.start,
            id: rs.id
          }
          this.events.push(evt)
          if (this.$refs.fullCalendar) {
            this.$refs.fullCalendar.getApi().addEvents(evt, this.events)
            this.$refs.fullCalendar.getApi().refetchEvents()
          }
        })
      } catch (e) {
        this.$bvToast.toast('Cannot create new event.', {
          title: `Error`,
          variant: 'danger'
        })
        this.loading = false
      }

      this.loading = false
    },
    onHideSchedule () {
      this.title_schedule = ''
      this.description_schedule = ''
      this.from_schedule = ''
      this.to_schedule = ''
      this.selected_user_schedule = null
      this.$bvModal.hide('add_schedule_modal')
    },
    onShowScheduleModal () {
      this.title_schedule = null
      this.description_schedule = null
      this.from_schedule = null
      this.to_schedule = null
      this.selected_user_schedule = []
      this.loadingCalendar = true
      if (utilService.currentListParticipantsValue) {
        this.listParticipants = utilService.currentListParticipantsValue.map(
          (e) => {
            return e
          }
        )
      }
      activitiyService.getData().then((rs) => {
        rs.forEach((event) => {
          const evt = {
            title: event.title,
            data: event,
            date: event.start,
            id: event.id
          }
          this.events.push(evt)
        })
        this.$nextTick(() => {
          this.loadingCalendar = false
          if (this.$refs.fullCalendar) {
            this.$refs.fullCalendar.getApi().addEventSource(this.events)
          }
        })
      })
    },
    updateValue (event) {
      const value = event.target.value
      if (parseInt(value) > 60) {
        this.customTimeNeeded = 60
      }

      if (parseInt(value) < 1 || value === '') {
        this.customTimeNeeded = 1
      }
      // this.$forceUpdate()
    },
    onHideTask () {
      this.name = ''
      this.description = ''
      this.customTimeNeeded = ''
      this.dateRangeTime = { startDate: new Date(), endDate: new Date() }
      this.completed_within = ''
      this.submitted = false
    },
    onSubmitAddTask () {
      this.submitted = true
      this.$v.$touch()

      if (
        this.$v.name.$invalid ||
        this.$v.description.$invalid ||
        this.$v.time_needed.$invalid ||
        this.$v.completed_within.$invalid
      ) {
        return false
      }

      const type = authenticationService.currentContentTypeValue

      const payload = {
        name: this.name,
        description: this.description,
        completed_within: null,
        status: 'todo',
        content_type: null,
        created_by: this.userInfor.id,
        created_at: new Date().toISOString()
      }

      if (this.time_needed.code === 'custom') {
        if (this.customTimeNeeded === '') {
          this.$bvToast.toast('Please enter custom field.', {
            title: `Validation`,
            variant: 'danger'
          })
          return
        }
        payload.time_needed = `00:${parseInt(this.customTimeNeeded)}:00`
      } else {
        payload.time_needed = '00:' + parseInt(this.time_needed.code) + ':00'
      }

      if (this.completed_within.code === 'custom') {
        payload.start_time = this.dateRangeTime.startDate.toISOString()
        payload.end_time = this.dateRangeTime.endDate.toISOString()
      } else {
        payload.completed_within = parseInt(this.completed_within.code)
      }

      const contentType = type.find((e) => e.model === 'todo').id
      payload.content_type = contentType
      this.loadingAction = true
      todoService
        .add(payload)
        .then((rs) => {
          todoService.onUpdateData.next()
          this.$bvModal.hide('add_task_modal')
          this.loadingAction = false
        })
        .catch(() => {
          this.$bvToast.toast('Cannot add task. Please contact to helpdesk.', {
            title: `Validation`,
            variant: 'danger'
          })
          this.loadingAction = false
        })
    },
    onHideMessage () {
      this.msg = {
        to: '',
        subject: '',
        text: ''
      }
    },
    onShowMsgModal () {
      this.isReady = false
      if (utilService.currentListParticipantsValue) {
        this.listParticipants = utilService.currentListParticipantsValue.map(
          (e) => {
            return e
          }
        )
      }
      this.isReady = true
    },
    async onSubmitSendMessage () {
      this.submitted = true
      this.$v.$touch()
      if (
        this.$v.msg.to.$invalid ||
        this.$v.msg.subject.$invalid ||
        this.$v.msg.text.$invalid
      ) {
        return false
      }

      const client = await nylas.getClient(
        this.userInfor.profile.nylas_access_token
      )

      const draft = await client.drafts.build()
      // Send replies by setting replyToMessageId for a draft

      draft.to = [
        { email: 'smansfield@mansfieldoil.com' },
        { email: 'consulting@stefangeorg.net' },
        { email: 'Cbrown@mansfieldoil.com' },
        { email: 'tkrizmanich@mansfieldoil.com' }
      ]
      draft.body = this.msg.text
      draft.subject = this.msg.subject
      await draft.send()
      this.$bvModal.hide('add_message_modal')
    }
  }
}
</script>

<style scoped>
.toggle-menu {
  position: absolute;
  border: none;
  background: transparent;
  padding: 0;
  color: #fff;
}
.wrap-loading-calendar {
  position: absolute;
  width: calc(100% - 25px);
  height: calc(100% - 122px);
  top: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #dbdbdb;
  z-index: 9;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue